<template>
  <component
    :is="tag"
    :class="buttonClasses"
    :disabled="disabled || loading"
    v-bind="$attrs"
    @click="handleClick"
  >
    <div v-if="loading" class="loading-spinner mr-2"></div>
    <i v-if="icon && !loading" :class="iconClasses"></i>
    <slot></slot>
  </component>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'BaseButton',
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: value =>
        [
          'primary',
          'secondary',
          'outline',
          'success',
          'warning',
          'danger',
        ].includes(value),
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: 'button',
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const buttonClasses = computed(() => {
      const baseClass = 'btn-base';
      const variantClass = `btn-${props.variant}`;
      const sizeClass = {
        sm: 'px-3 py-1.5 text-xs',
        md: 'px-4 py-2 text-sm',
        lg: 'px-6 py-3 text-base',
      }[props.size];

      return [baseClass, variantClass, sizeClass];
    });

    const iconClasses = computed(() => {
      const baseIconClass = props.icon;
      const sizeClass = {
        sm: 'text-xs',
        md: 'text-sm',
        lg: 'text-base',
      }[props.size];

      return [baseIconClass, sizeClass, 'mr-2'];
    });

    const handleClick = event => {
      if (!props.disabled && !props.loading) {
        emit('click', event);
      }
    };

    return {
      buttonClasses,
      iconClasses,
      handleClick,
    };
  },
};
</script>
